<template>
  <button
    class="button__violet button-hover-to-white cursor-pointer"
    @click="isOpen = true"
  >
    {{ title }}
  </button>

  <Teleport to="body">
    <div
      v-if="isOpen"
      class="fixed inset-0 z-[9999] flex items-center justify-center bg-black/60 p-4"
      @click.self="isOpen = false"
    >
      <div class="relative w-full max-w-lg max-h-[90vh] rounded-2xl bg-white overflow-hidden">
        <div class="overflow-y-auto max-h-[90vh] p-6 sm:p-8">
          <button
            class="sticky top-0 float-right ml-4 cursor-pointer border-none bg-transparent text-gray-400 transition-colors"
            aria-label="Schliessen"
            @click="isOpen = false"
          >
            <i class="fa-solid fa-x blue link-hover-to-blue-light"></i>
          </button>
          <div v-html="richtext"></div>
        </div>
      </div>
    </div>
  </Teleport>
</template>

<script setup lang="ts">
import { ref, watch, onMounted, onUnmounted } from "vue";

defineProps<{
  title: string;
  richtext: string;
}>();

const isOpen = ref(false);
let savedScrollY = 0;

watch(isOpen, (val) => {
  if (val) {
    savedScrollY = window.scrollY;
    document.body.style.position = 'fixed';
    document.body.style.top = `-${savedScrollY}px`;
    document.body.style.width = '100%';
  } else {
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.width = '';
    window.scrollTo(0, savedScrollY);
  }
});

const onKeydown = (e: KeyboardEvent) => {
  if (e.key === "Escape") isOpen.value = false;
};

onMounted(() => {
  document.addEventListener("keydown", onKeydown);
});

onUnmounted(() => {
  document.removeEventListener("keydown", onKeydown);
  document.body.style.position = '';
  document.body.style.top = '';
  document.body.style.width = '';
});
</script>
